import request from '@/utils/http/vr-request'
const BASE_URL = "cockpit";


//PDM订单产品分布数据
export function getOrderGoods(param) {
  return request({
    url: `${BASE_URL}/get_order_goods`,
    method: 'post',
    data: param
  })
}

//PDM门型销售榜
export function getDoor(param) {
  return request({
    url: `${BASE_URL}/get_door`,
    method: 'post',
    data: param
  })
}

//获取转单延期数据
export function getTransferDelay(param) {
  return request({
    url: `${BASE_URL}/get_transfer_delay`,
    method: 'post',
    data: param
  })
}

//PDM订单处理情况
export function getOrderHandlingData(param) {
  return request({
    url: `${BASE_URL}/get_order_handling_data`,
    method: 'post',
    data: param
  })
}

//获取商家每日订单统计
export function getDailyOrder(param) {
  return request({
    url: `${BASE_URL}/get_daily_order`,
    method: 'post',
    data: param
  })
}